export type Review = {
  quote: string
  name: string
  role: string
  city: string
  country: string
}

/**
 * Reseñas de compradores. Con el array vacío la sección no se renderiza.
 * PENDIENTE: faltan las frases de Olivia M. (AcroYoga Instructor, Austin)
 * y Oliver W. (Partner Yoga Teacher, Bristol) — agregarlas cuando estén.
 */
export const reviews: Review[] = [
  {
    quote:
      'Before, I kept stopping the class to figure out what everyone should work on next. Having Ground, Lift, and Fly options in one plan makes it easier to keep different levels practicing at the same time.',
    name: 'Ethan R.',
    role: 'Certified AcroYoga Teacher',
    city: 'San Diego, California',
    country: 'United States',
  },
  {
    quote:
      'I wanted to introduce partner acro at my retreats without building every session from scratch. The ready-to-teach format gives me a starting point, with easier options for guests who are completely new to it.',
    name: 'Chloe B.',
    role: 'Partner Acrobatics Instructor',
    city: 'Portland, Oregon',
    country: 'United States',
  },
  {
    quote:
      'Our jams used to depend heavily on who showed up and what people felt like practicing. Having a few structured challenges and progressions gives newcomers a clearer place to start.',
    name: 'Mason T.',
    role: 'Acro Yoga Workshop Facilitator',
    city: 'Denver, Colorado',
    country: 'United States',
  },
  {
    quote:
      'I noticed that beginners had a clearer starting point when we offered the Ground version first. More experienced partners could work on the next progression while I checked in with the newer students.',
    name: 'Amelia C.',
    role: 'AcroYoga Instructor',
    city: 'London',
    country: 'United Kingdom',
  },
]
